const INSPECTOR_KEY = "__VTK_ANALYTICS_INSPECTOR__";
const SENSITIVE_KEY = /(email|phone|full.?name|signature|token|secret|password|authorization|storage|signed.?url|file.?name|prospect|customer.?name)/i;
const SAFE_ITEM_KEYS = new Set(["item_id", "item_name", "item_category", "item_variant", "price", "quantity"]);

function safePrimitive(value) {
  if (typeof value === "number") return Number.isFinite(value) ? value : undefined;
  if (typeof value === "boolean") return value;
  if (typeof value === "string") return value.trim().slice(0, 150);
  return undefined;
}

export function sanitizeAnalyticsParams(params = {}) {
  const safe = {};
  for (const [key, value] of Object.entries(params || {})) {
    if (SENSITIVE_KEY.test(key) || /^(agreement|payment|square).*(id|key|token)$/i.test(key) ||
      /^(uid|user_id)$/i.test(key) || value === undefined || value === null) continue;
    if (key === "items" && Array.isArray(value)) {
      safe.items = value.slice(0, 50).map((item) => Object.fromEntries(
        Object.entries(item || {}).filter(([itemKey]) => SAFE_ITEM_KEYS.has(itemKey))
          .map(([itemKey, itemValue]) => [itemKey, safePrimitive(itemValue)])
          .filter(([, itemValue]) => itemValue !== undefined && itemValue !== ""),
      ));
      continue;
    }
    const primitive = safePrimitive(value);
    if (primitive !== undefined && primitive !== "") safe[key] = primitive;
  }
  return safe;
}

export function recordAnalyticsInspection(eventName, params, browserWindow) {
  const targetWindow = browserWindow || (typeof window !== "undefined" ? window : null);
  if (!targetWindow || process.env.REACT_APP_DEPLOY_ENV !== "staging") return;
  const existing = targetWindow[INSPECTOR_KEY];
  const events = Array.isArray(existing?.events) ? existing.events : [];
  const next = [...events, Object.freeze({eventName, params: sanitizeAnalyticsParams(params)})].slice(-200);
  targetWindow[INSPECTOR_KEY] = Object.freeze({
    events: Object.freeze(next),
    counts: Object.freeze(next.reduce((result, event) => ({
      ...result, [event.eventName]: (result[event.eventName] || 0) + 1,
    }), {})),
  });
}
